<template>

    <div id="app" class="">
        <keep-alive>
        <router-view
            :brands="brands"
            :categories="categories"
            :initialFilters="filters"
            :sorts="sorts"
            :prefilteredProducts="products"
            :prefilteredCounts="counts"
            :prefilteredPages="pages"
            :initialActiveFilters="active_filters"
        />
        </keep-alive>
        <section class="spacer-10x" />
    </div>

</template>

<script>

    export default {

        data: () => ({
            ...data,
            ...prefilter
        }),

        mounted: function() {

        },

        components: {

        }
    }

</script>

<style lang="scss">


    // TODO: check: do we need to import font awesome here at all??
    $fa-font-path: "../node_modules/@fortawesome/fontawesome-pro/webfonts";
    @import '../node_modules/@fortawesome/fontawesome-pro/scss/fontawesome';
    @import '../node_modules/@fortawesome/fontawesome-pro/scss/solid';
    @import '../node_modules/@fortawesome/fontawesome-pro/scss/regular';

    #app {

    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .slide-enter-active,
    .slide-leave-active {
        max-height: 500px;
        transition: all 0.3s ease;
        // overflow: hidden;
    }
    .slide-enter,
    .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
        max-height: 0;
        opacity: 0;
        // transition: all 0.5s ease;
        // overflow: hidden;
        // transition: all 0.3s ease;
    }

</style>
